import moment from "moment";
import { FormikDataEntryValues, FormikMainInsured } from "src/types/formik";
import { FormikMainInsuredGroup } from "src/types/formik/group.types";

export const getInitialValues: FormikDataEntryValues = {
  coverage_radios: "id_daily",
  coverage_type_radios: "1",
  coverage_start_date: moment().format('DD/MM/YYYY'),
  coverage_end_date: moment().format('DD/MM/YYYY'),
  insured_days: "daily",
  insured_daily: "daily_1",
  convention: "",
  insured_number: "1",
  insured_name: "",
  insured_surname: "",
  insured_email: "",
  insured_email_confirm: "",
  insured_phone: {
    country: {
      name: '',
      dialCode: '',
      countryCode: '',
      format: '',
    },
    formattedPhone: '',
    value: '',
  },
  insured_cap: "",
  insured_vat_number: "",
  insured_nationality: "italy_id",
  insured_fc_question: "",
  insured_birth: "",
  insured_birth_nation: "",
  insured_birth_place: "",
  insured_gender: "",
  insured_fc: "",
  consent_td: true,
  consent_privacy: false,
  consent_marketing: false,
  consent_profiling: false,
  consent_communication: false,
  insured_list: [],
  informative_vision: false,
  is_family: false,
  discount: "",
  registration_file: undefined,
};

export const getMainInsuredInitialValues: FormikMainInsured = {
  is_insured: "id_yes",
  coverage_type_radios: '1',
  coverage_start_date: moment().format('DD/MM/YYYY'),
  coverage_end_date: moment().format('DD/MM/YYYY'),
  convention: '',
  insured_name: '',
  insured_surname: '',
  insured_email: '',
  insured_email_confirm: '',
  insured_phone: {
    country: {
      name: '',
      dialCode: '',
      countryCode: '',
      format: '',
    },
    formattedPhone: '',
    value: '',
  },
  insured_cap: '',
  insured_vat_number: '',
  insured_nationality: 'IT',
  insured_fc_question: '',
  insured_birth: '',
  insured_birth_nation: '',
  insured_birth_place: '',
  insured_gender: '',
  insured_days: 'daily',
  insured_daily: 'daily_1',
  insured_fc: '',
  consent_td: true,
  consent_privacy: false,
  consent_marketing: false,
  consent_profiling: false,
  consent_communication: false,
  insured_list: [],
  informative_vision: false,
  discount: '',
  insured_number: '1',
  is_family: false,
}

export const getGroupInitialValues: FormikMainInsuredGroup = {
  group: [],
  originGroup: [],
  fileNames: [],
  fileStatus: undefined,
  mainInsured: {
    id: undefined,
    isInsured: 'id_yes',
    name: '',
    surname: '',
    email: '',
    emailConfirm: '',
    phone: {
      country: '',
      formattedPhone: '',
      value: '',
    },
    cap: '',
    vatNumber: '',
    nationality: 'IT',
    fiscalCodeQuestion: '',
    birthDate: '',
    birthNation: '',
    birthPlace: '',
    gender: '',
    fiscalCode: '',
    consentTd: true,
    consentPrivacy: false,
    consentMarketing: false,
    consentProfiling: false,
    consentCommunication: false,
    informativeVision: false,
    discount: '',
  },
}
